import { Component } from '@angular/core';
import { SavedCartFormDialogComponent } from '@spartacus/cart/saved-cart/components';

@Component({
  selector: 'app-save-cart-dialog',
  templateUrl: './save-cart-dialog.component.html',
  styleUrl: './save-cart-dialog.component.scss',
})
export class SaveCartDialogComponent extends SavedCartFormDialogComponent {}
